import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : hocr rendering support
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { Actions, Sel } from 'uix/registries';
import log from 'uix/logging';
import { GenericTagHandlerWithAttrFilter, SUI_MENU_ITEM_ATTRS } from 'uix/wiki/utils';
import { XMenu } from 'uix/components';
import { useActions, useSelector } from 'uix/hooks';
// ---Exports
const LogItem = ({ content, channel, icon = 'binoculars', ...props })=>{
    let logstream = useSelector((root)=>root.meta.logstream);
    let [toggleLogStream, setLogStream] = useActions([
        'toggleLogStream',
        'setLogStream'
    ]);
    // XXX: twisted activation logic
    let onClick = logstream.on && !(logstream.channel == channel) ? ()=>setLogStream({
            channel
        }) : ()=>toggleLogStream({
            channel
        });
    if (!content) {
        content = channel.startsWith('vls.') ? channel.slice(4) : channel;
    }
    return /*#__PURE__*/ _jsx(XMenu.Item, {
        active: logstream.on && logstream.channel == channel,
        content: content,
        onClick: onClick,
        icon: icon,
        ...props
    });
};
export const xmenu_logitem = GenericTagHandlerWithAttrFilter('XMenu.LogItem', ({ attrib })=>/*#__PURE__*/ _jsx(LogItem, {
        ...attrib
    }), {
    ...SUI_MENU_ITEM_ATTRS,
    channel: [
        'vls.sys'
    ]
}, `open a log channel`);
